import { render, staticRenderFns } from "./StudyBulkAnswerHorizontal.vue?vue&type=template&id=705d2ffc&scoped=true&lang=pug"
import script from "./StudyBulkAnswerHorizontal.vue?vue&type=script&lang=ts"
export * from "./StudyBulkAnswerHorizontal.vue?vue&type=script&lang=ts"
import style0 from "./StudyBulkAnswerHorizontal.vue?vue&type=style&index=0&id=705d2ffc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705d2ffc",
  null
  
)

export default component.exports